const e="item_category",t=t=>(t??[]).reduce(((t,c,o)=>(t[o>0?`${e}${o+1}`:e]=c,t)),{});export{e as ITEM_CATEGORY,t as getGtmItemCategories};
